export var graphData = {
    computed : {
        lineGraph : function(){
            return {
                title : {
                    show : true,
                    color: '#000',
                    // padding: 20,
                },
                tooltip: {
                    trigger: 'axis',
                    // formatter : function(params){
                    //     var temp = '';
                    //     temp = temp + params[0].name + '</br>';     //displayed triggered x-axis
                    //     for(var i=0;i<params.length;i++){
                    //         temp = temp + params[i].marker + params[i].seriesName + ' '+ (params[i].value == undefined ? '-' : params[i].value) + (params[i].value == undefined ? ' ' : '%') + '</br>';
                    //     }
                    //     return temp;
                    // },
                    // formatter : (params) => (`${params[0].name}<br/><span style="background-color: ${params[0].color}; border-radius: 50px;">&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;${params[0].seriesName}: ${params[0].value} %`)
                },
                legend: {
                    show: false,
                    data: this.lineGraphLegends
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                yAxis: this.lineGraphYaxis,
                xAxis: this.lineGraphXaxis,
                color: this.graphColors,
                series: this.lineGraphSeries,
            }
        }
    },
    data () {
        return {
            lineGraphLegend: {
                type: 'scroll',
                itemGap : 20,
                top: 10,
                show: true,
            },
            graphColors: ['#a4cd3c'],
            lineGraphLegends: [],
            lineGraphSeries:[],
            lineGraphYaxis: {
                min: 0,
                max: 50,
                interval: 10,
                axisLabel:{
                    // formatter: function (value) {
                    //     // return value.toFixed();
                    //     // return Math.round(value);
                    //     // console.log(value)
                    // },
                    fontStyle: 'normal' ,
                    fontWeight: 500 ,
                    fontFamily: 'Montserrat' ,
                    // fontSize: 10,
                    // margin: 15,
                    color: '#000',
                    // margin: 20
                },
                axisTick: {
                    show: false,
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: ['#ddd'],
                        width: 1,
                        // type: 'dotted',
                    }
                },
                type: 'value',
                scale : true,
                splitLine: {
                    show: true,
                    lineStyle: {
                        color: ['#ccc'],
                        width: 1,
                        // type: 'dotted',
                    }
                },
            },
            lineGraphXaxis:{
                axisTick: {
                    show: false,
                },
                axisLine: {
                    show: false,
                },
                axisLabel: {
                    fontStyle: 'normal' ,
                    fontWeight: 500 ,
                    fontFamily: 'Montserrat' ,
                    color: '#000',
                    margin: 20
                },
                type: 'category',
                boundaryGap: false,
                data: [],
                scale : true,
                min:0,
                max: '',
            },
            initOptions : {renderer : 'svg'},
            loading: true,
        }
    }
}
